<template>
  <router-view />
</template>

<script>
export default {
  name: "AnalyteSingle"
};
</script>